/**
 * UI-only display names for SAV roles. The backend role names (and their
 * `roleKey`s) are unchanged — this only affects what the user sees. Anything
 * not in the map falls back to its original name.
 */
const ROLE_DISPLAY_NAMES: Record<string, string> = {
  // Keyed by both the backend role name and the role key, since the table
  // renders role keys (e.g. "ROLE_SAV_ISPMADMIN") while the modal uses names.
  "ISPM Viewer": "Viewer",
  "ISPM Admin": "Admin",
  ROLE_SAV_ISPMVIEWER: "Viewer",
  ROLE_SAV_ISPMADMIN: "Admin",
};

/** Returns the friendly display label for a role name or role key. */
export function getRoleDisplayName(role: string): string {
  return ROLE_DISPLAY_NAMES[role] ?? role;
}
